module.exports = __webpack_public_path__ + "b8df0b38e8dc268e99abebe59b6261df.svg";